import PropTypes from 'prop-types';

const AiAssistantTaskPicker = ({
  tasks,
  activeTask,
  onSelect,
  disabled = false,
  className = 'ai-assistant-suggestions',
  ariaLabel = 'AI tasks',
}) => (
  <div className={className} role="group" aria-label={ariaLabel}>
    {tasks.map((task) => {
      const active = task.key === activeTask;
      return (
        <button
          key={task.key}
          className={`btn btn-sm ${task.className || ''} ${
            active ? task.activeVariant || 'btn-primary' : task.variant || 'btn-outline-primary'
          }`.trim()}
          type="button"
          aria-pressed={activeTask == null ? undefined : active}
          onClick={() => onSelect(task.key)}
          disabled={disabled || task.disabled}
          title={task.title}
        >
          {task.iconClass ? <i className={`bi ${task.iconClass} me-1`} aria-hidden="true"></i> : null}
          {task.label}
        </button>
      );
    })}
  </div>
);

AiAssistantTaskPicker.propTypes = {
  tasks: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconClass: PropTypes.string,
    className: PropTypes.string,
    variant: PropTypes.string,
    activeVariant: PropTypes.string,
    disabled: PropTypes.bool,
    title: PropTypes.string,
  })).isRequired,
  activeTask: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default AiAssistantTaskPicker;
